import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { zones } from "@/data/zones";

const sortedZones = [...zones].sort((a, b) => Number(b.priority) - Number(a.priority));

const Zones = () => (
  <div data-testid="zones-page">
    <Seo
      title="Zones d’intervention Fast Alu | Maisons-Alfort et Val-de-Marne"
      description="Découvrez toutes les zones d’intervention Fast Alu : Maisons-Alfort, Créteil, Charenton-le-Pont, Vitry-sur-Seine, et plus encore."
    />
    <section className="bg-brand-blue/5" data-testid="zones-hero">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl uppercase" data-testid="zones-title">
          Zones d’intervention
        </h1>
        <p className="text-brand-ink/70 mt-4" data-testid="zones-text">
          Maisons-Alfort est notre zone prioritaire. Nous couvrons également l’ensemble du Val-de-Marne.
        </p>
      </div>
    </section>

    <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-6">
      {sortedZones.map((zone) => (
        <Link
          key={zone.slug}
          to={`/${zone.slug}`}
          className={`border p-6 rounded-sm transition hover:border-brand-red ${
            zone.priority ? "border-brand-red bg-brand-red/10" : "border-brand-blue/15 bg-white"
          }`}
          data-testid={`zones-card-${zone.slug}`}
        >
          <h2 className="font-heading text-2xl uppercase" data-testid={`zones-name-${zone.slug}`}>
            {zone.name} {zone.postalCode ? `(${zone.postalCode})` : ""}
          </h2>
          <p className="text-sm text-brand-ink/70 mt-2" data-testid={`zones-desc-${zone.slug}`}>
            {zone.description}
          </p>
          <span className="text-xs uppercase text-brand-red mt-4 inline-flex" data-testid={`zones-cta-${zone.slug}`}>
            Voir la page locale
          </span>
        </Link>
      ))}
    </div>
  </div>
);

export default Zones;
